import React from 'react'
import PropTypes from 'prop-types'
import { HEIGHT_INCH } from '../../../../constant/NUMERICAL_SELECT_OPTIONS'
import RegisteredFormField from '../../../common/RegisteredFormField'

const HeightSelectInches = ({ path }) => {
  return <RegisteredFormField
    inputType='select'
    path={`${path}.heightIn`}
    id='heightIn'
    options={HEIGHT_INCH}
    label='Height (In)'
    placeholder=' '
  />
}

HeightSelectInches.propTypes = {
  /** The redux object root path for this form field's parent */
  path: PropTypes.string.isRequired,
}

export default HeightSelectInches